// extracted by mini-css-extract-plugin
export var headarea = "header-module--headarea--864a8";
export var headertop = "header-module--headertop--5c827";
export var site_name = "header-module--site_name--da3c7";